import { render, staticRenderFns } from "./StoreData.vue?vue&type=template&id=5253d34d&scoped=true&"
import script from "./StoreData.vue?vue&type=script&lang=js&"
export * from "./StoreData.vue?vue&type=script&lang=js&"
import style0 from "./StoreData.vue?vue&type=style&index=0&id=5253d34d&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5253d34d",
  null
  
)

export default component.exports